import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import {
  getCSSColorText,
  getCSSSizeLgText,
  getCSSSizeMdText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import { ArticleContext } from '~/contexts/ArticleContext';
import { getFontSizeObject } from '~/utilities/getFontSizeObject';
import { useIsPremiumTemplate } from '~/utilities/useIsPremiumTemplate';

const cssClasses = cva('my-2.5', {
  variants: {
    color: getCSSColorText(),
    sizeSm: getCSSSizeSmText(),
    sizeMd: getCSSSizeMdText(),
    sizeLg: getCSSSizeLgText(),
    isPremium: {
      true: 'mt-6 !text-[28px] md:my-[20px] max-md:mb-4 leading-[32px] lg:!text-[45px] lg:leading-[50px]',
      false: '',
    },
  },
});

export default component$((): JSX.Element => {
  const article = useContext(ArticleContext);

  if (!article) return <></>;

  const { themeComponents } = useContext(AppDataContext);
  const isPremium = useIsPremiumTemplate();

  return (
    <h1
      class={cssClasses({
        color: themeComponents.articleTitle.titleColor.value,
        ...getFontSizeObject(themeComponents.articleTitle, 'fontSize'),
        isPremium,
      })}
    >
      {article.title}
    </h1>
  );
});
